import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Snackbar,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { LEAVE_API_SUBMIT } from "../../constants";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export const LeaveComponent = ({ open, onClose, pageType, refresh }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [leaveType, setLeaveType] = useState("");
  const [remarks, setRemarks] = useState("");

  const employeeId = localStorage.getItem("username");
  const navigate = useNavigate();

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const [loading, setLoading] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleSubmit = async () => {
    const payload = {
      employeeId,
      startDate,
      endDate,
      leaveType,
      remarks,
    };
    try {
      setLoading(true);
      const response = await axios.post(`${LEAVE_API_SUBMIT}`, payload);
      const { data } = response.data;
      console.log(data);

      if(pageType === ''){
      setOpenConfirmDialog(true);
      } else {
        onClose();
        refresh();
      }
      handleReset();
    } catch (error) {
      console.error("Error submitting actions:", error);
      setSeverity('error');
      setMessage(error.response.data.message);
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }

    // onClose();
  };

  const handleReset = () => {
    setEndDate("");
    setStartDate("");
    setLeaveType("");
    setRemarks("");
  };

  const onConfirm = () => {
    navigate("/");
    localStorage.clear();
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullScreen>
        {/* Header */}
        <DialogTitle
          sx={{
            background: (theme) => theme.palette.primary.main,
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontWeight: "bold",
            padding: "16px 24px",
          }}
        >
          Leave Request
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ color: "#fff" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {/* Content */}
        <DialogContent sx={{ padding: "24px" }}>
          <Box component="form" noValidate autoComplete="off" sx={{ mt: 2 }}>
            <Grid container spacing={3}>
              {/* Start Date */}
              <Grid item xs={12}>
                <TextField
                  label="Start Date"
                  type="date"
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={startDate}
                  onChange={(e) =>
                    setStartDate(dayjs(e.target.value).format("YYYY-MM-DD"))
                  }
                  onKeyDown={(e) => e.preventDefault()}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
              </Grid>

              {/* End Date */}
              <Grid item xs={12}>
                <TextField
                  label="End Date"
                  type="date"
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={endDate}
                  onChange={(e) =>
                    setEndDate(dayjs(e.target.value).format("YYYY-MM-DD"))
                  }
                  onKeyDown={(e) => e.preventDefault()}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  select
                  label="Type of Leave"
                  fullWidth
                  size="small"
                  value={leaveType}
                  onChange={(e) => setLeaveType(e.target.value)}
                >
                  <MenuItem value={"SICK_LEAVE"}>Sick Leave</MenuItem>
                  <MenuItem value={"PAID_LEAVE"}>Paid Leave</MenuItem>
                  <MenuItem value={"REGIONAL_HOLIDAY"}>
                    Regional Holiday
                  </MenuItem>
                  <MenuItem value={"UNPAID_LEAVE"}>Unpaid Leave</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  id="outlined-multiline-static"
                  label="Remarks"
                  multiline
                  rows={4}
                  fullWidth
                  value={remarks}
                  style={{ resize: "both", overflow: "auto" }}
                  onChange={(e) => {
                    setRemarks(e.target.value);
                  }}
                />
              </Grid>

              {/* Submit Button */}
              <Grid item xs={12} sx={{ textAlign: "center", mt: 2 }}>
                <Button
                  variant="contained"
                  sx={{
                    background:
                      "linear-gradient(135deg, #4CAF50 30%, #2E7D32 90%)",
                    color: "white",
                    fontWeight: "bold",
                    textTransform: "none",
                    borderRadius: "8px",
                    padding: "12px 32px",
                    fontSize: "16px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                    transition: "0.3s",
                    "&:hover": {
                      background:
                        "linear-gradient(135deg, #2E7D32 30%, #1B5E20 90%)",
                      boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.3)",
                    },
                  }}
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <CircularProgress size={24} color="inherit" /> &nbsp;
                    </>
                  ) : (
                    "Submit Request"
                  )}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>

      <LogoutConfirmationDialog
        open={openConfirmDialog}
        onCloseDialog={() => setOpenConfirmDialog(false)}
        onConfirm={onConfirm}
      />

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000} // Snackbar will auto hide after 6 seconds
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};

const LogoutConfirmationDialog = ({ open, onCloseDialog, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          onCloseDialog();
        }
      }}
      disableEscapeKeyDown
    >
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Leave applied successfully. You will be logged out now.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {/* <Button onClick={onClose} color="primary">Cancel</Button> */}
        <Button onClick={onConfirm} color="error" variant="contained">
          Logout
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeaveComponent;
